import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ContainerButton from '../../../components/button/ContainerButton';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../components/state-component/StateComponents';
import { VisaTypeApi } from '../../../api/visa-type/visa-type.api';
import { Avatar, Box, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Tab, Tabs, Typography } from '@mui/material';
import InputTextField from '../../../components/input/inputTextField';
import AddImage from "../../../assets/icons/add_image.png";
import { ReactComponent as CloseCircle } from "../../../assets/icons/close-circle.svg";
import { handleTypingNumber } from '../../../utils/app.utils';
import InputDatePicker from '../../../components/input/inputDatePicker';
import moment from 'moment';
import { routeName } from '../../../routes/routeName';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { VisaFormApi } from '../../../api/visa-form/visa-form.api';
import { alertActive, alertError, alertSuccess, swalError, swalSuccess } from '../../../components/alert/swal';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { RequestFormCreate } from './visa-request-create';
import { VisaRequestFrontApi } from '../../../api/visa-request-front/visa-request-front.api';
import { StudentApi } from '../../../api/student/student.api';
import StepperCustom from '../../../components/step/Stepper';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import { ButtonContained } from '../../../components/button/ButtonCustoms';
import CancelIcon from '@mui/icons-material/Cancel';
import { dateToView, timeToView } from '../../../utils/date.utils';
import { renderStatus, STATUS_VISA } from '../manage-request/enum/request-form.enum';
import StatusCustom from '../../../components/status/statusCustom';
import ModalCustom from '../../../components/modal/ModalCustom';
import InfoIcon from '@mui/icons-material/Info';
import { VisaSatisfactionApi } from '../../../api/visa-satisfaction/visa-satisfaction.api';

export default function VisaRequestDetail(props: any) {
    const { view } = props
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const uploadRefs = useRef<any>();

    const navigate = useNavigate()
    const [pathUrl, setPathUrl] = useState<any>(null);
    const { profile } = useSelector((state: any) => state.profile);
    const [student, setStudent] = useState<any>({})
    const [formPayment, setFormPayment] = useState<any>()
    const [showModal, setShowModal] = useState<string>("");
    const [remark, setRemark] = useState<string>("");
    const [showModalGuestion, setShowModalGuestion] = useState<string>("");
    const [indexFile, setIndexFile] = useState<number>(0);

    const [form, setForm] = useState<any>({
        visa_form_name: ''
    });
    const [keyword, setKeyword] = useState<string>("");
    const [dataDropdown, setDataDropdown] = useState<any[]>([]);
    const [visaFormDocuments, setVisaFormDocuments] = useState<any[]>([]);
    const [filesVisa, setFilesVisa] = useState<any[]>([]);

    const [visaType, setVisaType] = useState<any[]>([]);
    const [files, setFiles] = useState<any[]>([]);
    const [filesRemove, setFilesRemove] = useState<any[]>([]);
    const [visaSatisfaction, setVisaSatisfaction] = useState<any[]>([]);
    const [visaSatisfactionDetail, setVisaSatisfactionDetail] = useState<any>();
    const [value, setValue] = React.useState(0);
    const [errorMessage, setErrorMessage] = useState<any>()
    const clearErrorMessage = () => {
        setErrorMessage({})
    }
    const allStep = [
        {
            name: t("ผู้ประสานงานฯ"),
            isAccept: false,
            icon: <CloseCircle />
        },
        {
            name: t("เจ้าหน้าที่สารบรรณ"),
            isAccept: false,
            icon: <CloseCircle />
        },
        {
            name: t("เจ้าหน้าที่หอพัก"),
            isAccept: false,
            icon: null
        },
        {
            name: t("เจ้าหน้าที่กองกิจฯ"),
            isAccept: false,
            icon: null
        },
        {
            name: t("เจ้าหน้าที่กองวิเทศฯ"),
            isAccept: false,
            icon: null
        },

    ];
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const getVisaType = async () => {
        const param = {
            page: 1,
            limit: 100
        }
        await VisaTypeApi.list(param).then((res) => {
            if (res.status < 300) {
                setVisaType(res.data?.data.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results.REACT_APP_BASE_API_PUBLIC);
        };
        init();
    }, []);
    const findById = async () => {

        await VisaRequestFrontApi.findById(id).then((res) => {
            if (res.status < 300) {
                setForm(res.data?.data);
                setStudent(res.data?.data);
                // setFilesVisa(res.data?.data?.visa_form_files)
                setVisaFormDocuments(res.data?.data?.visa_form_document)
                findByIdVisaForm(res.data?.data?.id_visa_form)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const findByIdVisaForm = async (id: number) => {

        await VisaFormApi.findById(id).then((res) => {
            if (res.status < 300) {
                // setForm(res.data?.data);
                setFilesVisa(res.data?.data?.visa_form_files)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getVisaSatisfaction = async () => {

        await VisaSatisfactionApi.list().then((res) => {
            if (res.status < 300) {
                // setForm(res.data?.data);
                setVisaSatisfaction(res.data?.data)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getVisaSatisfactionDetail = async () => {

        await VisaSatisfactionApi.visarequest(id).then((res) => {
            if (res.status < 300) {
                // setForm(res.data?.data);
                setVisaSatisfactionDetail(res.data?.data)
                if (res.data?.data) {
                    setRemark(res.data?.data?.remark)
                    setVisaSatisfaction(res.data?.data?.visa_satisfaction_details)

                } else {
                    getVisaSatisfaction()
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getVisaType()
        findById()
        getVisaSatisfactionDetail()
    }, [])
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: 1,
            limit: 10
        }
        if (keyword) query = { ...query, search: keyword }

        await VisaFormApi.dropdown(query).then((res) => {
            if (res.status < 300) {
                setDataDropdown(res.data?.data?.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [keyword])

    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const handleSubmit = async (type?: string) => {
        // if (!form?.admission_student?.id_academic_year) {
        //     return alertError('Specify Academic Year')
        // }
        // if (!form?.admission_student?.id_degree) {
        //     return alertError('Specify Degree')
        // }
        // if (!form?.admission_student?.id_faculty) {
        //     return alertError('Specify Faculty')
        // }

        console.log(form);
        if (!form.province) {
            return setErrorMessage((prev: any) => ({ ...prev, province: "Specify Province" }))
        }
        if (!form.district) {
            return setErrorMessage((prev: any) => ({ ...prev, district: "Specify District" }))
        }
        if (!form.district_sub) {
            return setErrorMessage((prev: any) => ({ ...prev, district_sub: "Specify State" }))
        }
        if (!form.post_code) {
            return setErrorMessage((prev: any) => ({ ...prev, postcode: "Specify Postal/Zip Code" }))
        }


        const body = {
            ...form,
            id_student: student?.id_student,
            student_no: student?.student_no,
            title: student?.title,
            student_frist_name: student?.student_frist_name,
            student_middle_name: student?.student_middle_name,
            nationality: student?.nationality,
            id_course_of_study: student?.id_course_of_study,
            id_degree: student?.id_degree,
            id_faculty: student?.id_faculty,
            student_email: student?.student_email,
        }
        dispatch(setLoading());
        await VisaRequestFrontApi.patch(Number(id), body)
            .then(async (res) => {
                if (res.status < 300) {
                    if (visaFormDocuments?.filter((x) => x?.visa_request_documents.filter((y: any) => !y.id_visa_request_document).length > 0)?.length > 0) {
                        const formData = new FormData();

                        visaFormDocuments?.filter((x) => x?.visa_request_documents.filter((y: any) => !y.id_visa_request_document).length > 0).forEach((file) => {
                            for (const element of file.visa_request_documents.filter((x:any) => !x?.id_visa_request_document)) {
                                formData.append("files", element);
                                formData.append("id_visa_form_document", file.id_visa_form_document);
                                formData.append("id_visa_step", file.id_visa_step);
                                formData.append("document_name", file.document_name);
                                formData.append("document_type", file.document_type);

                            }

                        });

                        await VisaRequestFrontApi.file(res.data.data.id_visa_request, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    if (type) {
                                        handleSent()
                                    } else {
                                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => findById());

                                    }
                                }
                            })
                    } else {
                        if (type) {
                            handleSent()
                        } else {
                            alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => findById());
                        }

                    }
                }
            })
            .catch((err) => {
                console.log(err);
                alertError("Save Draft", err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });


    }
    const handleSent = async () => {

        dispatch(setLoading());

        await VisaRequestFrontApi.sent_coordinator(Number(id))
            .then((res) => {
                if (res.status < 300) {

                    alertSuccess(t("สร้างรายการส่งคำร้อง"), t("สร้างรายการส่งคำร้อง เรียบร้อยแล้ว"), undefined, () => {
                        navigate(routeName.request_form.visa_request)
                    })


                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("บันทึก"), err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
        // }

    }
    const handleQuestion = async () => {

        const body = {
            id_visa_request: id,
            remark: remark,
            visa_satisfaction_details: visaSatisfaction?.map((item: any) => {
                return {
                    "id_visa_satisfaction_question": item?.id_visa_satisfaction_question,
                    "visa_satisfaction_question_name": item?.visa_satisfaction_question_name,
                    "point": item?.point
                }
            })
        }
        dispatch(setLoading());

        await VisaSatisfactionApi.post(body)
            .then((res) => {
                if (res.status < 300) {

                    alertSuccess(t("ประเมินความพึ่งพอใจ"), t("ประเมินความพึ่งพอใจ เรียบร้อยแล้ว"), undefined, () => {
                        navigate(routeName.request_form.visa_request)
                    })


                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("ประเมินความพึ่งพอใจ"), err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
        // }

    }
    const handlePayment = async () => {
        if (formPayment?.file) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', formPayment?.file);
            formData.append('payment_date', `${formPayment?.payment_date}T${formPayment?.payment_date_time}`);
            formData.append('payment_currency', 'THB');
            formData.append('payment_type', 'ATTACH_SLIP');

            await VisaRequestFrontApi.paymentFile(id, formData).then((res: any) => {
                if (res.status < 300) {

                    swalSuccess(t('ยืนยันการชำระเงิน'), t('ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ'), undefined, () => {
                        navigate(routeName.request_form.visa_request)
                    })
                }
            }).catch((error: any) => {
                console.log(error)
                // if (fileRef.current) {
                //     fileRef.current.value = null;
                // }
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    // console.log(visaSatisfactionDetail);
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("รายละเอียดคำร้อง")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ระบบคำร้อง"),
                                disabled_match: true,
                                pathName: routeName.request_form.visa_request
                            },
                            {
                                key: "complaintSubmit",
                                name: t("ส่งคำร้อง"),
                                pathName: routeName.request_form.visa_request
                            },
                            {
                                key: "complaintSubmit",
                                name: t("รายละเอียดคำร้อง"),
                                pathName: routeName.request_form.visa_request_detail.replace(':id', `${id}`)
                            },
                        ]}
                    />
                }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <ContainerButton
                        // sxContainer={{ my: 3 }}
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                seq: 1,
                                buttonProps: {
                                    onClick: () => { navigate(-1) },
                                },
                                key: "CANCEL",
                                label: t("LIST_APPLICANTS_BACK"),
                                type: "CANCEL"
                            },
                            {
                                seq: 2,
                                hidden: view || ![STATUS_VISA.DRAFT].includes(form?.status_visa),
                                buttonProps: {
                                    onClick: () => {
                                        //   setShowModal('REJECT')
                                        handleSubmit()
                                    }
                                },
                                key: "SAVE_DRAFT",
                                label: t("บันทึกร่าง", { context: "action" }),
                                type: 'SAVE_DRAFT'
                            },
                            {
                                seq: 2,
                                hidden: view || [STATUS_VISA.WAITING_PAYMENT].includes(form?.status_visa) && value !== 1.5,
                                buttonProps: {
                                    onClick: () => {
                                        if (value === 1.5) {
                                            handlePayment()
                                        } else {
                                            alertActive(t("ยึนยันสร้างรายการส่งคำร้อง"), t("ต้องการสร้างรายการส่งคำร้องหรือไม่ ?"), undefined, undefined, async () => {
                                                // handleSent()
                                                handleSubmit('SENT')
                                            })
                                        }

                                        // handleSubmit()
                                    }
                                },
                                key: "SAVE",
                                label: t("ยืนยัน"),
                                type: 'SAVE'
                            },
                            {
                                seq: 2,
                                hidden: ![STATUS_VISA.COMPLETE].includes(form?.status_visa),
                                buttonProps: {
                                    onClick: () => {
                                        setShowModalGuestion('ADD')
                                    }
                                },
                                key: "SAVE",
                                label: t("ประเมินความพึ่งพอใจ"),
                                type: 'APPROVE',
                            },
                        ]}
                    />
                }
                content={
                    <>
                        <Box sx={{ display: "flex", gap: '5px', alignItems: 'center', marginBottom: '10px' }}>
                            <IconButton onClick={() => setShowModal('SHOW')}><InfoIcon />
                            </IconButton><Typography>{t("ข้อมูล")}</Typography>
                        </Box>
                        {[STATUS_VISA.REVIEW, STATUS_VISA.REJECT_REQUEST].includes(form?.status_visa) && <><Box sx={{ maxWidth: '300px', marginBottom: "10px" }}>
                            <StatusCustom
                                disableMaxWidth
                                text={t(renderStatus(form?.status_visa))}
                                type={renderStatus(form?.status_visa)}
                            />
                        </Box></>}
                        {[STATUS_VISA.REVIEW, STATUS_VISA.REJECT_REQUEST].includes(form?.status_visa) && <Typography sx={{ marginBottom: "20px" }}>{t("หมายเหตุ:")} {form?.remark}</Typography>}
                        {form?.visa_form?.id_visa_type === 18 ? ![STATUS_VISA.WAITING_RECEIVE_REQUEST, STATUS_VISA.RECEIVE_REQUEST].includes(form?.status_visa) &&
                            <section className="w-full">
                                <StepperCustom
                                    step={form?.status_visa === STATUS_VISA.WAITING_PAYMENT ? 2 : form?.status_visa === STATUS_VISA.WAITING_PAYMENT_VERIFICATION ? 3 : 4}
                                    setStep={(num: number) => {
                                        // setTebStep(num);
                                    }}
                                    stepLabel={[
                                        {
                                            visa_step: t('ผู้ประสานงานฯ')
                                        },
                                        {
                                            visa_step: t('เจ้าหน้าที่ทะเบียน')
                                        },
                                        {
                                            visa_step: t('ชำระเงิน')
                                        },
                                        {
                                            visa_step: t('ตรวจสอบการชำระเงิน')
                                        },
                                    ]?.map((x: any) => {
                                        return {
                                            name: x?.visa_step,
                                            isAccept: false,
                                            icon: null
                                        }
                                    }) || []}
                                    // stepLabel={allStep}
                                    // view={true}
                                    sx={{ maxWidth: "800px" }}
                                />
                            </section>
                            : form?.visa_form?.id_visa_type === 16 ? <></>
                                : ![STATUS_VISA.DRAFT].includes(form?.status_visa) && <section className="w-full">
                                    <StepperCustom
                                        step={form?.status_visa === STATUS_VISA.COMPLETE ? form?.current_step?.id_visa_step - 1 : form?.current_step?.id_visa_step - 2}
                                        setStep={(num: number) => {
                                            // setTebStep(num);
                                        }}
                                        stepLabel={form?.visa_form?.visa_type?.visa_type_steps?.filter((x: any) => x?.id_visa_step !== 1)?.sort((a: any, b: any) => a?.seq - b?.seq)?.map((x: any) => {
                                            return {
                                                name: x?.visa_step?.visa_step,
                                                isAccept: false,
                                                icon: null
                                            }
                                        }) || []}
                                        // stepLabel={allStep}
                                        // view={true}
                                        sx={{ maxWidth: "800px" }}
                                    />
                                </section>
                        }
                        {![STATUS_VISA.DRAFT].includes(form?.status_visa) && <Tabs
                            sx={{
                                marginBottom: '20px', borderBottom: "2px solid #F2F4F7", '& .MuiTab-root': {
                                    background: '#F2F4F7'
                                }, '& .Mui-selected': {
                                    background: "#4A4A4A",
                                    color: "#FFFFFF !important"
                                }, '& .MuiTabs-indicator': {
                                    display: 'none'
                                }
                            }}
                            value={value}
                            onChange={handleChange}
                            // indicator="none"
                            aria-label="secondary tabs example"
                        >
                            <Tab label={t("รายละเอียด")} />
                            {[18].includes(form?.visa_form?.id_visa_type) && [STATUS_VISA.WAITING_PAYMENT, STATUS_VISA.WAITING_PAYMENT_VERIFICATION, STATUS_VISA.PAYMENT_COMPLETED, STATUS_VISA.COMPLETE].includes(form?.status_visa) && <Tab value={1.5} label={t("ข้อมูลการชำระเงิน")} />}
                            {[16, 18].includes(form?.visa_form?.id_visa_type) ? [STATUS_VISA.PAYMENT_COMPLETED, STATUS_VISA.COMPLETE].includes(form?.status_visa) ? <Tab value={2} label={t("สรุปผล")} /> : <></> : <Tab value={2} label={t("สรุปผล")} />}

                        </Tabs>}
                        {value === 0 &&
                            <RequestFormCreate view={view || [STATUS_VISA.WAITING_PAYMENT].includes(form?.status_visa)} form={form} setForm={setForm} student={student} setStudent={setStudent} getVisaForm={findById} visaForm={form?.visa_form} visaFormDocuments={visaFormDocuments} setVisaFormDocuments={setVisaFormDocuments} errorMessage={errorMessage} clearErrorMessage={clearErrorMessage} />
                        }
                        {value === 1.5 && <RegisterPayment view={view} form={form} setForm={setForm} formPayment={formPayment} setFormPayment={setFormPayment} />}
                        {value === 2 &&
                            <>{![16, 18].includes(form?.visa_form?.id_visa_type) ? <>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    sxContainer={{ marginBottom: '20px' }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            hidden: [8, 9, 10, 17].includes(form?.visa_form?.id_visa_type) || form?.current_step?.id_visa_step <= 3,
                                            fieldProps: {
                                                heading: t("Reference Number"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 3)?.refer_number || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, dormitory_name: e.target.value })
                                                },
                                                disabled: true
                                            }
                                        },
                                        {
                                            seq: 1.2,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            hidden: [8, 9, 10, 17].includes(form?.visa_form?.id_visa_type) || form?.current_step?.id_visa_step <= 4,
                                            fieldProps: {
                                                heading: t("Dormitory Name"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.dormitory_name || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, dormitory_name: e.target.value })
                                                },
                                                disabled: true
                                            }
                                        },

                                        {
                                            seq: 2,
                                            type: "SELECT",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            hidden: [8, 9, 10, 17].includes(form?.visa_form?.id_visa_type) || form?.current_step?.id_visa_step <= 4,
                                            fieldProps: {
                                                labelId: "ss",
                                                heading: "Dormitory Type",
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, dormitory_type: e.target.value })
                                                    // set_id_degree(e.target.value)
                                                },
                                                options: [
                                                    {
                                                        label: 'Male',
                                                        value: "Male",
                                                    },
                                                    {
                                                        label: 'Female',
                                                        value: "Female",
                                                    },
                                                ],
                                                selectId: "",
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.dormitory_type || '',
                                                disabled: true
                                            }
                                        },
                                        {
                                            seq: 3,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            hidden: [8, 9, 10, 17].includes(form?.visa_form?.id_visa_type) || form?.current_step?.id_visa_step <= 4,
                                            fieldProps: {
                                                heading: t("Room Number"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.room_number || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, room_number: e.target.value })
                                                },
                                                onkeypress: handleTypingNumber,
                                                disabled: true
                                            }
                                        },
                                        {
                                            seq: 4,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            hidden: [8, 9, 10, 17].includes(form?.visa_form?.id_visa_type) || form?.current_step?.id_visa_step <= 4,
                                            fieldProps: {
                                                heading: t("Floor Number"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.floor_number || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, floor_number: e.target.value })
                                                },
                                                onkeypress: handleTypingNumber,
                                                disabled: true
                                            }
                                        },
                                        {
                                            seq: 5,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            hidden: [8, 9, 10].includes(form?.visa_form?.id_visa_type) || form?.current_step?.id_visa_step <= 4,
                                            fieldProps: {
                                                heading: t("หมายเหตุ"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 7)?.remark || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, remark: e.target.value })
                                                },
                                                minRow: 8,
                                                multiline: true,
                                                inputHeight: "auto",
                                                disabled: true
                                            }
                                        },

                                    ]} />

                                <Box sx={{
                                    border: '1px solid #DDE1EB',
                                    borderRadius: '18px', overflow: 'hidden'
                                }}>
                                    <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                    </Box>
                                    <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {form?.visa_form_document?.map((x: any) => {
                                            return (
                                                <>
                                                    {x?.visa_request_documents?.map((y: any) => {
                                                        return (
                                                            <Box sx={{
                                                                border: '1px solid #DDE1EB',
                                                                borderRadius: '18px', overflow: 'hidden',
                                                                padding: '10px 15px'
                                                            }}>
                                                                <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{x?.document_name}</Typography>
                                                                <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                    <Typography sx={{
                                                                        width: '100%', overflow: "hidden",
                                                                        display: "-webkit-box",
                                                                        WebkitBoxOrient: "vertical",
                                                                        WebkitLineClamp: "1",
                                                                    }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                    <OptionsButtonCustom
                                                                        // enableEdit
                                                                        enableView
                                                                        onViewClick={() => { window.open(y?.id_visa_request_document ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                    // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                    />
                                                                </Box>
                                                            </Box>
                                                        )
                                                    })}
                                                </>

                                            )
                                        })}


                                    </Box>
                                </Box>
                            </> :
                                [16].includes(form?.visa_form?.id_visa_type) ?
                                    <div className='w-full'>
                                        <StateComponents
                                            otherProps={{ spacing: 2 }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                    },
                                                    fieldProps: {
                                                        heading: t("หมายเหตุ"),
                                                        value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 8)?.remark || '',
                                                        onChange: (e) => {
                                                            // setFormAccepting({ ...formAccepting, remark: e.target.value })
                                                        },
                                                        minRow: 8,
                                                        multiline: true,
                                                        inputHeight: "auto",
                                                        disabled: true
                                                    }
                                                },



                                            ]} />
                                    </div>
                                    : <>
                                        <StateComponents
                                            otherProps={{ spacing: 2 }}
                                            sxContainer={{ marginBottom: '20px' }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                    },
                                                    fieldProps: {
                                                        heading: t("สถานที่สอบ"),
                                                        value: form?.visa_examination?.visa_examination_name || '',
                                                        onChange: (e) => {
                                                            // setFormAccepting({ ...formAccepting, visa_examination_name: e.target.value })
                                                        },
                                                        disabled: true
                                                    }
                                                },

                                                {
                                                    seq: 2,
                                                    type: "DATE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        onChange: (e) => {
                                                            // setFormAccepting({ ...formAccepting, visa_examination_start_date: moment(e).format('YYYY-MM-DD') })
                                                        },
                                                        heading: t('วันที่เริ่มต้น'),
                                                        placeholder: t('วันที่เริ่มต้น'),
                                                        allowClear: true,
                                                        onClear: () => {
                                                            // setFormAccepting({ ...formAccepting, visa_examination_start_date: '' })
                                                        },
                                                        value: form?.visa_examination?.visa_examination_start_date,
                                                        disabled: true
                                                    },
                                                },
                                                {
                                                    seq: 4,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        heading: t("เวลาเริ่มต้น"),
                                                        onChange: (e) => {
                                                            // setFormAccepting({ ...formAccepting, visa_examination_start_time: e.target.value })
                                                        },
                                                        value: timeToView(form?.visa_examination?.visa_examination_start_date),
                                                        type: 'time',
                                                        disabled: true
                                                    }
                                                },
                                                {
                                                    seq: 3,
                                                    type: "DATE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        onChange: (e) => {
                                                            // setFormAccepting({ ...formAccepting, visa_examination_end_date: moment(e).format('YYYY-MM-DD') })
                                                        },
                                                        heading: t('วันที่สิ้นสุด'),
                                                        placeholder: t('วันที่สิ้นสุด'),
                                                        allowClear: true,
                                                        onClear: () => {
                                                            // setFormAccepting({ ...formAccepting, visa_examination_end_date: '' })
                                                        },
                                                        value: form?.visa_examination?.visa_examination_end_date,
                                                        disabled: true
                                                    },
                                                },
                                                {
                                                    seq: 5,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        heading: t("เวลาสิ้นสุด"),
                                                        onChange: (e) => {
                                                            // setFormAccepting({ ...formAccepting, visa_examination_end_time: e.target.value })
                                                        },
                                                        value: timeToView(form?.visa_examination?.visa_examination_end_date),
                                                        type: 'time',
                                                        disabled: true
                                                    }
                                                },

                                            ]} />
                                        <Box sx={{
                                            border: '1px solid #DDE1EB',
                                            borderRadius: '18px', overflow: 'hidden'
                                        }}>
                                            <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                            </Box>
                                            <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                {form?.visa_examination?.visa_examination_files?.map((y: any) => {
                                                    return (
                                                        <Box sx={{
                                                            border: '1px solid #DDE1EB',
                                                            borderRadius: '18px', overflow: 'hidden',
                                                            padding: '10px 15px'
                                                        }}>
                                                            <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{t('ไฟล์แนบ')}</Typography>
                                                            <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                <Typography sx={{
                                                                    width: '100%', overflow: "hidden",
                                                                    display: "-webkit-box",
                                                                    WebkitBoxOrient: "vertical",
                                                                    WebkitLineClamp: "1",
                                                                }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                <OptionsButtonCustom
                                                                    // enableEdit
                                                                    enableView
                                                                    onViewClick={() => { window.open(y?.id_visa_examination_file ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                />
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}


                                            </Box>
                                        </Box>
                                    </>}
                            </>
                        }
                    </>
                }
            />
            {showModal !== '' && (
                <ModalCustom
                    open
                    title={'IBSC General Request Form'}
                    subTitle={t("Guideline for Requesting a Certification of Student")}
                    onClose={() => setShowModal('')}

                    containerButton={{
                        onClose: () => setShowModal(''),
                        hidden_submit: true
                    }}
                    component={
                        <div className='w-full'>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "15px" }}>
                                {filesVisa?.map((_, i) => {
                                    return (
                                        <Avatar sx={{ width: 24, height: 24, background: indexFile === i ? '#FCAF17' : "#F2F4F7", color: indexFile === i ? '#fff' : "#000" }} onClick={() => setIndexFile(i)}>{i + 1}</Avatar>
                                    )
                                })}
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {filesVisa?.filter((_, i) => i === indexFile)?.map((item: any) => {
                                    return (
                                        <img src={`${pathUrl}/${item?.file_path}${item?.file_name}`} style={{
                                            maxWidth: '100%',
                                            height: '500px',
                                            objectFit: "contain",
                                            objectPosition: 'center'
                                        }} />
                                    )
                                })}
                            </Box>

                        </div>
                    }
                />
            )}
            {showModalGuestion !== '' && (
                <ModalCustom
                    open
                    title={t('ประเมินความพึ่งพอใจ')}
                    // subTitle={t("Guideline for Requesting a Certification of Student")}
                    onClose={() => setShowModalGuestion('')}

                    containerButton={{
                        onClose: () => setShowModalGuestion(''),
                        hidden_submit: visaSatisfactionDetail,
                        onSubmit: () => {
                            handleQuestion()
                        }
                    }}
                    component={
                        <div className='w-full'>
                            <Box sx={{ width: "100%", display: 'flex', }}>
                                <Box style={{ width: "50%" }}></Box>
                                <Box
                                    style={{
                                        width: "50%",
                                        display: 'flex',
                                        justifyContent: "space-around",
                                    }}
                                >

                                    {[t('น้อยมาก'), t('น้อย'), t('ปานกลาง'), t('ดี'), t('ดีมาก')].map((num, i) => (
                                        <Typography key={i} sx={{ width: '100px', textAlign: 'center' }}>{num}</Typography>
                                    ))}
                                </Box>
                            </Box>
                            {visaSatisfaction?.map((item: any, i: number) => {
                                return (
                                    <Box
                                        key={i}
                                        sx={{
                                            width: "100%",
                                            display: 'flex',
                                            borderBottomWidth: 1,
                                            borderBottomColor: "#e7e7e7",
                                            paddingVertical: 5,
                                        }}
                                    >
                                        <Box sx={{ width: "50%", display: "flex", alignItems: 'end' }}>
                                            <Typography>{i + 1}. {item?.visa_satisfaction_question_name}</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                width: "50%",
                                                display: 'flex',
                                                justifyContent: "space-around",
                                            }}
                                        >
                                            {[1, 2, 3, 4, 5].map((num) => (
                                                <Radio
                                                    key={num}
                                                    value={num}
                                                    disabled={visaSatisfactionDetail}
                                                    checked={item?.point == num ? true : false}
                                                    onChange={(e) => {
                                                        setVisaSatisfaction((prevData) =>
                                                            prevData.map((p) =>
                                                                p.id_visa_satisfaction_question === item?.id_visa_satisfaction_question
                                                                    ? {
                                                                        ...p,
                                                                        point: e.target.value,
                                                                    }
                                                                    : p
                                                            )
                                                        );
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>

                                )
                            })}
                            <Box sx={{ marginTop: '20px' }}>
                                <InputTextField disabled={visaSatisfactionDetail} heading={t("รายละเอียดเพิ่มเติม")} value={remark} onchange={(e) => setRemark(e.target.value)} multiline minRow={3} inputHeight={'auto'} />
                            </Box>

                        </div>
                    }
                />
            )}

        </div >
    )
}

export const RegisterPayment = (props: any) => {
    const { t } = useTranslation();
    const { form, setForm, formPayment, setFormPayment } = props
    const fileRef = useRef<any>()
    const { id } = useParams()
    // const [type, setType] = useState<string>('THB')
    const [pathUrl, setPathUrl] = useState<string>("");
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);
    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            setFormPayment({ ...formPayment, file: event.target.files[0] })
            // const formData = new FormData();

            // //DRAFT
            // formData.append('file', event.target.files[0]);
            // formData.append('id_admission_student', `${id}`);
            // formData.append('payment_catalog', 'REGISTER');

            // await AdmissionFrontApi.register_payment_file(formData).then((res: any) => {
            //     if (res.status < 300) {
            //         setForm({ ...form, admission_student_register_payment: { ...form?.admission_student_register_payment, id_admission_student_register_payment: res.data.data?.id_admission_student_register_payment, payment_file: res.data.data } })
            //         if (fileRef.current) {
            //             fileRef.current.value = null;
            //         }
            //         // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
            //     }
            // }).catch((error: any) => {
            //     console.log(error)
            if (fileRef.current) {
                fileRef.current.value = null;
            }
            //     swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            // })

        }
    }
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <Grid container spacing={2}>


                    <Grid item xs={12} md={[STATUS_VISA.WAITING_PAYMENT].includes(form?.status_visa) ? 4 : 8}>
                        <Box sx={{
                            // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "40px",
                            borderRadius: "20px",
                            display: "flex",
                            flexDirection: 'column',
                            gap: '10px',
                            background: '#F6F6F6',
                            height: '600px',
                            justifyContent: 'space-between'
                        }}>
                            <Box sx={{
                                display: "flex",
                                flexDirection: 'column',
                                gap: '10px',
                            }}>
                                <Typography sx={{ fontWeight: "600", color: '#4A4A4A' }}>{t("บิลเลขที่")} {form?.visa_payment?.invoice_no}</Typography>

                                <Grid container spacing={2}>

                                    <Grid item xs={12} >
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'column', }}>
                                                <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                                    <Typography sx={{ color: "#000" }}>{t("ชื่อผู้ทำรายการ")}</Typography>
                                                    <Typography sx={{ color: "#000" }}>{form?.student_frist_name} {form?.student_middle_name}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                                    <Typography sx={{ color: "#000" }}>{t("ออกบิลเมื่อ")}</Typography>
                                                    <Typography sx={{ color: "#000" }}>{form?.visa_payment?.created_date ? dateToView(form?.visa_payment?.created_date) : '-'}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                                    <Typography sx={{ color: "#000" }}>{t("กรุณาชำระก่อน")}</Typography>
                                                    <Typography sx={{ color: "#000" }}>{form?.visa_form?.payment_period_day_end ? dateToView(form?.visa_form?.payment_period_day_end) : '-'}</Typography>
                                                </Box>

                                            </Box>
                                            <Box sx={{ border: '1px dashed #DDE1EB', width: "100%" }}></Box>
                                            <Typography>Register Qualify Examination (QE)</Typography>
                                            <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                                <Typography sx={{ color: "#000" }}>{t("จำนวน 1 รายการ")} </Typography>
                                                <Typography sx={{ color: "#000" }}>{Number(form?.visa_payment?.payment_amount)?.toFixed(2)?.toLocaleString()} {t("บาท")}</Typography>
                                            </Box>
                                            <Box sx={{ border: 'px dashed #DDE1EB', width: "100%" }}></Box>

                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                <Typography sx={{ color: "#000", fontSize: '18px', fontWeight: '600' }}>{t("ยอดสุทธิ")}</Typography>
                                <Typography sx={{ color: "#000", fontSize: '18px', fontWeight: '600' }}>{Number(form?.visa_payment?.payment_amount)?.toFixed(2)?.toLocaleString()} {t("บาท")}</Typography>
                            </Box>
                        </Box>

                    </Grid>
                    {[STATUS_VISA.WAITING_PAYMENT].includes(form?.status_visa) && <Grid item xs={12} md={4}>
                        <Box sx={{
                            // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "40px",
                            borderRadius: "20px",
                            display: "flex",
                            flexDirection: 'column',
                            gap: '10px',
                            background: '#F6F6F6',
                            height: '600px'
                        }}>

                            <Typography sx={{ fontWeight: "600", color: '#4A4A4A' }}>{t("ช่องทางการชำระเงิน")}</Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                </Grid>
                                <Grid item xs={12} >
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                            <Typography sx={{ color: "#737373" }}>{t("ชื่อบัญชี")} </Typography>
                                            <Typography sx={{ color: "#000" }}>{form?.visa_payment?.payment_channels?.account_name_th}</Typography>

                                        </Box>
                                        <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                            <Typography sx={{ color: "#737373" }}>Account Name </Typography>
                                            <Typography sx={{ color: "#000" }}>{form?.visa_payment?.payment_channels?.account_name_eng}</Typography>

                                        </Box>
                                        <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                            <Typography sx={{ color: "#737373" }}>{t("เลขที่บัญชี")} </Typography>
                                            <Typography sx={{ color: "#000" }}>{form?.visa_payment?.payment_channels?.account_no}</Typography>
                                        </Box>
                                        <Typography sx={{ color: "#737373" }}>Account No.</Typography>

                                        <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                                            <Typography sx={{ color: "#737373" }}>Account Type </Typography>
                                            <Typography sx={{ color: "#000" }}>{form?.visa_payment?.payment_channels?.account_type}</Typography>

                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                    </Grid>}
                    <Grid item xs={12} md={4}>
                        <Box sx={{
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "10px",
                            borderRadius: "20px",
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: "center",
                            justifyContent: "center",
                            position: 'relative',
                            height: '500px'
                        }} >
                            {form?.visa_payment?.file_path || formPayment?.file ?
                                <img src={form?.visa_payment?.file_path ? pathUrl + '/' + form?.visa_payment?.file_path + form?.visa_payment?.file_name : URL.createObjectURL(formPayment?.file)} style={{ width: '100%', maxHeight: '450px', objectFit: 'contain' }} /> :
                                <>
                                    <ButtonContained buttonName='Choose Image' onClick={() => fileRef.current.click()} />
                                </>
                            }
                            <input ref={fileRef} className='hidden' type='file'
                                accept={"image/*"}
                                onChange={(e: any) => onImageChange(e)} />
                            {formPayment?.file &&
                                <IconButton sx={{ position: "absolute", top: '20px', right: '20px' }} onClick={() => {
                                    setFormPayment({ ...formPayment, file: undefined })
                                }}><CancelIcon sx={{ color: "#e7e7e7" }} /></IconButton>}
                        </Box>
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            sxContainer={{ marginTop: '20px' }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "DATE",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        onChange: (e) => {
                                            setFormPayment({ ...formPayment, payment_date: moment(e).format('YYYY-MM-DD') })
                                        },
                                        heading: 'Payment Date',
                                        placeholder: 'Payment Date',
                                        allowClear: true,
                                        onClear: () => {
                                            setFormPayment({ ...formPayment, payment_date: '' })
                                        },
                                        value: form?.visa_payment?.payment_date ? form?.visa_payment?.payment_date : formPayment?.payment_date,
                                        disabled: form?.visa_payment?.payment_date
                                    },
                                },
                                {
                                    seq: 2,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        heading: "Payment Time",
                                        onChange: (e) => {
                                            setFormPayment({ ...formPayment, payment_date_time: e.target.value })
                                        },
                                        value: form?.visa_payment?.payment_date ? timeToView(form?.visa_payment?.payment_date) : formPayment?.payment_date_time,
                                        type: 'time',
                                        disabled: form?.visa_payment?.payment_date
                                    }
                                },

                                {
                                    seq: 4,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        heading: "Amount",
                                        onChange: (e) => {
                                            setFormPayment({ ...formPayment, payment_amount: e.target.value })
                                        },
                                        value: form?.visa_payment?.payment_date ? form?.visa_payment?.payment_amount : formPayment?.payment_amount,
                                        onkeypress: handleTypingNumber,
                                        disabled: form?.visa_payment?.payment_date
                                    }
                                },

                            ]} />
                    </Grid>
                </Grid>



            </Box>
        </>
    )
}